import Select from "react-select";


export function SearchSelect(props) {
  const options = props?.data?.map((item) => {
    let label;
    if (props.combinedOptions) {
      label = item[props.labelField] + " - " + item[props.combinedLabel];
    } else if (props.labelField1 && props.labelField2 && item[props.labelField] == null) {
      label = item[props.labelField1] + "-" + item[props.labelField2];
    } else {
      label = item[props.labelField];
    }

    return {
      label,
      value: item[props.valueField]
    };
  }) || [];

  // Create styles with width prop if provided
  const createStyles = (width) => ({
    menu: (provided) => ({
      ...provided,
      width: width || '100%',
      minWidth: 'max-content'
    }),
    control: (provided) => ({
      ...provided,
      width: width || 'auto'
    })
  });

  // Determine styles priority: customstyles > customstyles2 > stylegreen > width-based
  const selectStyles = props.customstyles || props.customstyles2 || props.stylegreen || (props.width ? createStyles(props.width) : {});

  // Handle required prop - default to true unless explicitly set to false or mandatory is defined
  const isRequired = props.mandatory !== undefined ? props.mandatory : (props.required !== false);

  return (
    <Select
      id={props.id}
      name={props.name}
      classNamePrefix="select"
      options={options}
      styles={selectStyles}
      required={isRequired}
      value={props.value && { label: props.value, value: props.value }}
      isDisabled={props.disabled}
      readOnly={props.readOnly}
      placeholder={props.placeholder || ""}
      onChange={props.onChange}
      onKeyDown={props.onBlur}
    />
  );
}

export default SearchSelect;